var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"category-box"},[_c('img',{attrs:{"src":_vm.imageUrl,"alt":_vm.title}}),_c('b-link',{attrs:{"to":_vm.link}},[_c('label',{staticClass:"regular-18"},[_vm._v(_vm._s(_vm.buttonText))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }